export function showNotice() {
  window.Didomi.notice.show()
}

export function showPurposes() {
  window.Didomi.preferences.show('purposes')
}

export function showVendors() {
  window.Didomi.preferences.show('vendors')
}
